module.exports = __webpack_public_path__ + "static/media/ico-notransaksi.42f35c45.png";